import { selectSizesWithPhotos } from '../stores/selectors';

// Build payload to be sent to backend to save changes
export const buildSaveOrderPayload = (
  photos,
  allSizes,
  selectedDeliveryKey,
) => {
  const sizesWithPhotos = selectSizesWithPhotos(allSizes, photos);
  const toBeDeleted = photos
    .filter((p) => p.quantity <= 0 && p.id)
    .map((p) => p.id);

  return {
    sizes: sizesWithPhotos
      .map((size) => ({
        photos: size.photos
          .filter((p) => p.currentVersion !== p.savedVersion)
          .map((photo) => {
            const photoPayload = {
              id: photo.id,
              quantity: photo.quantity,
              make_new_copy: !!photo.make_new_copy, // eslint-disable-line camelcase
              filename: photo.filename,
              filesize: photo.filesize,
              angle: photo.angle,
              colour_fx: photo.colour_fx, // eslint-disable-line camelcase
              crop: photo.crop,
              fx: photo.fx,
              gamma: photo.gamma,
              saturation: photo.saturation,
              straighten: photo.straighten,
              size_key: size.key, // eslint-disable-line camelcase
              delivery_option: selectedDeliveryKey, // eslint-disable-line camelcase
              client_uuid: photo.client_uuid, // eslint-disable-line camelcase
              currentVersion: photo.currentVersion,
            };
            photoPayload.image_id = photo.make_new_copy // eslint-disable-line camelcase
              ? photo.original_image_id
              : photo.image_id;
            return photoPayload;
          }),
        what: size.options.key,
      }))
      .filter((size) => size.photos.length > 0),
    to_be_deleted: toBeDeleted, // eslint-disable-line camelcase
  };
};
